import BlogController from "./BlogController";

export default BlogController;
